import { combineReducers } from 'redux';

import { generatorReducer } from './generator';
import { subscribeReducer } from './subscribe';
import { mapDownloadReducer } from './mapDownload';


const rootReducer = combineReducers({
    generator: generatorReducer,
    subscribe: subscribeReducer,
    mapDownload: mapDownloadReducer
});

export default rootReducer;